<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Regional">
        <template slot="button">
          <button-add v-if="cP(4)" :to="{name: 'regionals-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/regionals" :fields="fields">
            <template v-slot:3="data">
              <div class="float-none">
                <button-link v-if="cP(5)" size="sm" :to="{name:'regionals-edit',params:{id: data.item[3]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(6)" @ondelete="deleteRow" :id="data.item[3]" :name="data.item[0]"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Kode'},
        1:{sortable: true, searchable: true, label:'Nama'},
        2:{sortable: true, searchable: true, label:'Keterangan'},
        3:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('regionals/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>